import "./MobileView.css";

const MobileView = () => {
  return <div className="MobileContainer"></div>;
};

export default MobileView;
